import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import './FlightHeader.css';

const FlightHeader = ({ flightId, from, to, date, departTime, arriveTime }) => (
  <div className='flight-header-wrapper'>
    <div className='flight-header'>
      <div>
        <h6 className='left'>{Dictionary.review.konaShuttle}</h6>
        <h6 className='right'>
          {Dictionary.review.flight} <p>{flightId}</p>
        </h6>
      </div>
      <div>{date}</div>
      <div className='from-to-wrapper'>
        <div className='from-to'>
          <h6>{Dictionary.review.from}</h6>
          <p>{from}</p>
          <h6>{departTime}</h6>
        </div>

        <div className='from-to'>
          <h6>{Dictionary.review.to}</h6>
          <p>{to}</p>
          <h6>{arriveTime}</h6>
        </div>
      </div>
    </div>
  </div>
);

FlightHeader.propTypes = {
  flightId: PropTypes.string,
  from: PropTypes.string,
  to: PropTypes.string,
  date: PropTypes.string,
  departTime: PropTypes.string,
  arriveTime: PropTypes.string,
};

export default FlightHeader;



// WEBPACK FOOTER //
// ./src/components/review/flightHeader/FlightHeader.js